export default __webpack_public_path__ + "static/media/request-completed.3151c151.svg";